<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="text-center">
                <h2 class="display-1 font-weight-bold mb-6">Nuestros Servicios</h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="service in services" :key="service.title" cols="12" md="4">
                <v-hover v-slot:default="{ hover }">
                    <v-card class="pa-4 text-center" :elevation="hover ? 12 : 2">
                        <v-icon size="64" color="primary">{{ service.icon }}</v-icon>
                        <h3 class="title font-weight-bold mt-4">{{ service.title }}</h3>
                        <p>{{ service.description }}</p>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            services: [
                { title: 'Desarrollo de Software', icon: 'mdi-code-tags', description: 'Soluciones a medida para tu negocio.' },
                { title: 'Inteligencia Artificial', icon: 'mdi-brain', description: 'Automatización y análisis predictivo.' },
                { title: 'Ciberseguridad', icon: 'mdi-shield-lock', description: 'Protege tus datos y sistemas.' },
                { title: 'Cloud Computing', icon: 'mdi-cloud', description: 'Infraestructura escalable en la nube.' },
            ],
        };
    },
};
</script>